var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "div",
          {
            staticClass: "retentionAnalysisTitle commonalitText commonalityBox"
          },
          [_vm._v(" " + _vm._s(_vm.$t("showUserBehaviorPattern")) + " ")]
        ),
        _c(
          "div",
          {
            staticClass: "commonalityBox",
            class: { commonalityBox1: _vm.eventList.length > 4 }
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _vm._l(_vm.eventList, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticStyle: { display: "inline-block" } },
                    [
                      _c("el-col", { attrs: { span: 1.5 } }, [
                        _c("div", { staticClass: "commonalitText" }, [
                          _vm._v(" " + _vm._s(_vm.$t("eventLabel")) + " ")
                        ])
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 3.5 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                placeholder: _vm.$t("pleaseSelectBehavior")
                              },
                              model: {
                                value: item.begin_action,
                                callback: function($$v) {
                                  _vm.$set(item, "begin_action", $$v)
                                },
                                expression: "item.begin_action"
                              }
                            },
                            _vm._l(_vm.behaviorList, function(behavior, idx) {
                              return _c("el-option", {
                                key: idx,
                                attrs: {
                                  label: behavior.label,
                                  value: behavior.value
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "inline-block" } },
                        [
                          _c("el-button", {
                            staticStyle: { margin: "0 10px 0" },
                            attrs: {
                              size: "mini",
                              type: "danger",
                              circle: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeActionItem(index)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block" } },
                  [
                    _c("el-button", {
                      staticStyle: { margin: "0 10px 0" },
                      attrs: {
                        size: "mini",
                        type: "primary",
                        circle: "",
                        icon: "el-icon-plus"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.addActionItem()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: " commonalityBox" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 1.5 } }, [
                  _c("div", { staticClass: "commonalitText" }, [
                    _vm._v(" " + _vm._s(_vm.$t("userMatchCriteria")) + " ")
                  ])
                ]),
                _vm.rawData.game_show_type == 1
                  ? _c(
                      "el-col",
                      { attrs: { span: 3.5 } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              multiple: "",
                              "collapse-tags": "",
                              filterable: "",
                              clearable: "",
                              placeholder: _vm.$t("selectProduct")
                            },
                            on: { change: _vm.productChange },
                            model: {
                              value: _vm.searchData.special_product_id,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.searchData,
                                  "special_product_id",
                                  $$v
                                )
                              },
                              expression: "searchData.special_product_id"
                            }
                          },
                          _vm._l(_vm.productsList, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: 3.5 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("selectAdChannel")
                        },
                        on: { change: _vm.advChannelchangeMore },
                        model: {
                          value: _vm.searchData.ad_channel,
                          callback: function($$v) {
                            _vm.$set(_vm.searchData, "ad_channel", $$v)
                          },
                          expression: "searchData.ad_channel"
                        }
                      },
                      _vm._l(_vm.advchannels, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label: item.adv_platform_name,
                            value: item.adv_platform_mark
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 3.5 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("selectAdPlacement")
                        },
                        model: {
                          value: _vm.searchData.ad_placement,
                          callback: function($$v) {
                            _vm.$set(_vm.searchData, "ad_placement", $$v)
                          },
                          expression: "searchData.ad_placement"
                        }
                      },
                      _vm._l(_vm.advLocation, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label: item.adv_place_name,
                            value: item.adv_place_mark
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 3.5 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("advertiser")
                        },
                        model: {
                          value: _vm.searchData.ad_id,
                          callback: function($$v) {
                            _vm.$set(_vm.searchData, "ad_id", $$v)
                          },
                          expression: "searchData.ad_id"
                        }
                      },
                      _vm._l(_vm.advertiserLists, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.ad_name, value: item.ad_id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 3.5 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("analysisType")
                        },
                        model: {
                          value: _vm.searchData.dimensionField,
                          callback: function($$v) {
                            _vm.$set(_vm.searchData, "dimensionField", $$v)
                          },
                          expression: "searchData.dimensionField"
                        }
                      },
                      _vm._l(_vm.analyzetypeList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: " commonalityBox" },
          [
            _c(
              "el-row",
              {
                staticClass: "commonalityJust",
                staticStyle: { padding: "30px 0" },
                attrs: { gutter: 20 }
              },
              [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        clearable: false,
                        "picker-options": _vm.pickerOptionsRadius,
                        "value-format": "yyyy-MM-dd",
                        type: "daterange",
                        placeholder: _vm.$t("pleaseSelectOperationTime")
                      },
                      model: {
                        value: _vm.value2,
                        callback: function($$v) {
                          _vm.value2 = $$v
                        },
                        expression: "value2"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticStyle: { display: "flex" }, attrs: { span: 2 } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.loadingBtn },
                        on: { click: _vm.searchList }
                      },
                      [_vm._v(_vm._s(_vm.$t("search")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "el-table",
          {
            ref: "tableRef",
            attrs: {
              id: "tableRef",
              data: _vm.tableNewData,
              border: "",
              "cell-class-name": _vm.cellStyle
            }
          },
          _vm._l(_vm.tableColumns, function(col) {
            return _c("el-table-column", {
              key: col.prop,
              attrs: {
                prop: col.prop,
                label: col.label,
                "min-width": "150",
                align: "center"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row[col.prop]
                          ? _c("div", { staticClass: "tableDataText" }, [
                              _c("div", { staticClass: "tableDataText-c" }, [
                                _vm._v(
                                  _vm._s(row[col.prop].count) +
                                    _vm._s(_vm.$t("personUnit"))
                                )
                              ]),
                              _c("div", { staticClass: "tableDataText-b" }, [
                                _vm._v(_vm._s(row[col.prop].percentage) + "%")
                              ])
                            ])
                          : _c("div", [_vm._v("-")])
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          }),
          1
        )
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tableData.length,
            expression: "tableData.length"
          }
        ],
        staticClass: "chart-controls",
        staticStyle: {
          margin: "20px 0",
          display: "flex",
          "justify-content": "flex-end",
          gap: "10px"
        }
      },
      [
        _c(
          "el-radio-group",
          {
            attrs: { size: "small" },
            on: { change: _vm.onMetricChange },
            model: {
              value: _vm.currentMetric,
              callback: function($$v) {
                _vm.currentMetric = $$v
              },
              expression: "currentMetric"
            }
          },
          [
            _c("el-radio-button", { attrs: { label: "count" } }, [
              _vm._v(_vm._s(_vm.$t("personCount")))
            ]),
            _c("el-radio-button", { attrs: { label: "percentage" } }, [
              _vm._v(_vm._s(_vm.$t("percentageWithSymbol")))
            ])
          ],
          1
        )
      ],
      1
    ),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.tableData.length,
          expression: "tableData.length"
        }
      ],
      staticStyle: { height: "650px" },
      attrs: { id: "timeFunnelEchart" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }